import { BoxV2 as Box } from 'portal-commons';
import { FunctionComponent, ReactElement } from 'react';
import { Tooltip, makeStyles } from '@material-ui/core';

interface DescriptionTooltipProps {
  rejectionCategory?: string;
  explanation: string;
  children: ReactElement;
}

interface TooltipTitleProps {
  rejectionCategory?: string;
  explanation: string;
}

const useStyles = makeStyles(() => ({
  customTooltip: {
    '&.MuiTooltip-tooltip': {
      maxWidth: '338px',
      padding: '6px 8px',
      borderRadius: '3px',
      color: '#fff',
      background: '#0091B3',
      fontSize: '12px',
      fontWeight: 400,
      wordBreak: 'break-all',
      whiteSpace: 'pre-line',
      boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.25);',
      boxSizing: 'border-box',
      '& .MuiTooltip-arrow': {
        color: '#0091B3',
      },
    },
  },
}));

const TooltipTitle: FunctionComponent<TooltipTitleProps> = ({
  rejectionCategory,
  explanation,
}) => (
  <>
    {!!rejectionCategory && (
      <>
        <Box as="span" sx={{ fontWeight: 800 }}>
          Rejection Category:
        </Box>
        {` ${rejectionCategory}`}
        <br />
        <br />
      </>
    )}
    <Box
      sx={{
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        WebkitLineClamp: 10,
        WebkitBoxOrient: 'vertical',
      }}
    >
      <Box as="span" sx={{ fontWeight: 800 }}>
        Explanation:{' '}
      </Box>
      {explanation}
    </Box>
  </>
);

const DescriptionTooltip: FunctionComponent<DescriptionTooltipProps> = ({
  rejectionCategory,
  explanation,
  children,
  ...props
}) => {
  const classes = useStyles();

  return (
    <Tooltip
      classes={{ tooltip: classes.customTooltip }}
      title={
        <TooltipTitle
          rejectionCategory={rejectionCategory}
          explanation={explanation}
        />
      }
      placement="left"
      arrow
      {...props}
    >
      {children}
    </Tooltip>
  );
};

export default DescriptionTooltip;
